import { compose } from 'recompose'
import { connect } from 'react-redux'
import { selectors as UISelectors } from 'data/ui'
import { selectors as ThreadsSelectors } from 'data/threads'
import { withNoteMetaPanelControls } from 'routes/utils/withNoteMetaPanelControls'

const MIN_WINDOW_WIDTH_TO_DISPLAY_COMMENTS = 1000

export default ({ CommentPlugin }) => ({
  decorator = x => x,
  CommentsEditor,
  createThread,
} = {}) => {
  return CommentPlugin({
    CommentsEditor,
    createThread,
    decorator: compose(
      decorator,
      withNoteMetaPanelControls,
      connect(
        (state, { mark }) => {
          const threadId = CommentPlugin.extractThreadIdFromMark(mark)
          const thread = ThreadsSelectors.getThread(state, threadId)
          const displayThread = thread && !thread.resolvedAt
          return {
            isDetachedMode: UISelectors.isDetachedModeEnabled(state),
            displayThread,
          }
        },
        null,
        (
          { isDetachedMode, displayThread },
          _,
          { showComments, ...restProps } = {}
        ) => {
          return {
            toggleComments: ({ threadId }) => {
              if (
                isDetachedMode &&
                window.outerWidth < MIN_WINDOW_WIDTH_TO_DISPLAY_COMMENTS
              ) {
                window.resizeTo(1000, window.outerHeight)
              }
              showComments({
                threadId,
              })
            },
            displayThread,
            ...restProps,
          }
        }
      )
    ),
  })
}
